export default "__VITE_ASSET__0ca78f17__"